import { createClient } from '@supabase/supabase-js'
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY
// #4 (v97): hybrid session storage.
// Browser: plain localStorage. Android app: also mirrors the session to native
// SharedPreferences (so background sync can refresh the token), and adopts any
// newer token that background sync saved while the app was closed. Supabase
// rotates refresh tokens, so JS and native must share ONE token chain.
function nativeBridge() {
  try {
    var b = typeof window !== 'undefined' ? window.AndroidBridge : null;
    return b && typeof b.getSessionJson === 'function' ? b : null;
  } catch (e) { return null; }
}
function isSessionKey(key) {
  return typeof key === 'string' && /-auth-token$/.test(key);
}
const hybridStorage = {
  getItem(key) {
    const local = localStorage.getItem(key);
    const b = nativeBridge();
    if (!b || !isSessionKey(key) || !local) return local; // never resurrect a signed-out session
    try {
      const raw = b.getSessionJson();
      if (!raw) return local;
      const n = JSON.parse(raw);
      const l = JSON.parse(local);
      if (n.access_token && n.refresh_token && n.refresh_token !== l.refresh_token &&
          (n.expires_at || 0) > (l.expires_at || 0)) {
        const merged = Object.assign({}, l, {
          access_token: n.access_token,
          refresh_token: n.refresh_token,
          expires_at: n.expires_at,
          expires_in: Math.max(0, n.expires_at - Math.floor(Date.now() / 1000)),
        });
        const s = JSON.stringify(merged);
        localStorage.setItem(key, s);
        return s;
      }
    } catch (e) {}
    return local;
  },
  setItem(key, value) {
    localStorage.setItem(key, value);
    const b = nativeBridge();
    if (!b || !isSessionKey(key) || typeof b.saveSessionTokens !== 'function') return;
    try {
      const s = JSON.parse(value);
      if (s && s.refresh_token) {
        b.saveSessionTokens(s.access_token || '', s.refresh_token, String(s.expires_at || 0));
      }
    } catch (e) {}
  },
  removeItem(key) {
    localStorage.removeItem(key);
    const b = nativeBridge();
    if (b && isSessionKey(key) && typeof b.clearSessionTokens === 'function') {
      try { b.clearSessionTokens(); } catch (e) {}
    }
  },
};

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: { storage: hybridStorage, persistSession: true, autoRefreshToken: true },
})
